import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
interface HeaderProps {
  onBookConsultation?: () => void;
}
export function Header({
  onBookConsultation
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 h-[60px] transition-all duration-300 ${isScrolled ? 'bg-cream/95 backdrop-blur-md border-b border-divider shadow-sm' : 'bg-transparent'}`} data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-full flex items-center justify-between" data-id="element-104">
        {/* Logo */}
        <a href="#" className="flex items-center" data-id="element-105">
          {isScrolled ? <img src="https://cdn.magicpatterns.com/uploads/fdmGiLysMPoebjoKSvto4r/Be_Clinical_logo_navy_hex.png" alt="Be Clinical" className="h-10 w-auto transition-all duration-300" data-id="element-106" /> : <img src="https://cdn.magicpatterns.com/uploads/pFJTFQ3dTz2bGqDseJkdZu/Be_Clinical_logo_white_hex.png" alt="Be Clinical" className="h-10 w-auto transition-all duration-300" data-id="element-107" />}
        </a>

        {/* Book Now Button */}
        <Button variant="primary" className="!min-h-[36px] !py-1.5 !px-4 text-xs !w-auto" onClick={onBookConsultation} data-id="element-108">
          Book Now
        </Button>
      </div>
    </header>;
}